import Cookies from 'js-cookie'

const AUTH_USER_DATA = 'AUTH_USER_DATA'

export const getUserData = () => {
  const { id, name, email } = Cookies.getJSON(AUTH_USER_DATA) || {}
  return { id, name, email }
}

export const getFirstname = () => {
  const { name } = Cookies.getJSON(AUTH_USER_DATA) || {}
  return /([^\s]+)/.exec(name)[0]
}
